var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import { filterOutReferencesWithoutChips } from '../editorState/richTextValueUtils';
/*
 * Ideally the collection of References used to populate Chips in RichTextEditor would come
 * from above the RichTextEditor component, without any need for local state.
 *
 * Unfortunately we do need additional local state:
 *
 * 1. When User adds Chip via Drag and Drop or removes Chip via delete icon click, we add or remove the chip's
 *      reference to collection to be persisted in backend, so that if eg. referenced object's name changes, this
 *      will be correctly reflected in the Chip when User next opens the Editor.
 *
 * 2. User can however then also add or remove Chips via native Undo/Redo commands. When this happens, DraftJS does
 *      not expose some opportunity to react to the change, and therefore we cannot correctly update the
 *      reference collection to reflect chip add/remove.
 *
 * The Reference Collection in app state is updated on every change to contain exactly those references for which
 *      there are currently Chips in Editor, so that this collection is always correct if User saves.
 *
 * Meanwhile we keep ALL references that were added in local state, even if the chip is later removed, so that if
 *      chip is "re-added" via undo/redo without any chance for us to react, we still have its reference to use
 *      to populate Chip and to update reference collection in app state.
 */
export var useLocalChipCollectionState = function (editorState, referenceCollection, setReferenceCollection) {
    var _a = React.useState(referenceCollection ? __spreadArray([], referenceCollection, true) : []), chipCollection = _a[0], setChipCollection = _a[1];
    useEffect(function () {
        if (setReferenceCollection) {
            setReferenceCollection(filterOutReferencesWithoutChips(editorState, chipCollection));
        }
    }, [editorState]);
    return [chipCollection, setChipCollection];
};
//# sourceMappingURL=useLocalChipCollectionState.js.map